import { render, staticRenderFns } from "./ChargeDetail.vue?vue&type=template&id=230e6fa8&scoped=true&"
import script from "./ChargeDetail.vue?vue&type=script&lang=js&"
export * from "./ChargeDetail.vue?vue&type=script&lang=js&"
import style0 from "./ChargeDetail.vue?vue&type=style&index=0&id=230e6fa8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "230e6fa8",
  null
  
)

export default component.exports